import { render, staticRenderFns } from "./PostedInvoices.vue?vue&type=template&id=135075ac"
import script from "./PostedInvoices.vue?vue&type=script&lang=js"
export * from "./PostedInvoices.vue?vue&type=script&lang=js"
import style0 from "./PostedInvoices.vue?vue&type=style&index=0&id=135075ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports